export default `
Du siehst diese Seite, weil entweder dein System Universal Links nicht unterstützt oder dies bei der Installation nicht eingerichtet wurde.  
Um dennoch die gewünschte Funktion freizuschalten, kannst du in der App unter "Code" folgenden Code eingeben:  

## {code}
`;
